import { supabase } from "./supabaseClient.js";
import { API_BASE_URL } from "../env.js";

/** Downloads a file from an /api/admin/* Function that returns a binary
 * attachment (not JSON) - e.g. a generated offline licence. The admin API
 * only accepts bearer-token auth (functions/lib/auth.ts), so this can't be a
 * plain anchor link: fetch the file as a blob with the session token
 * attached, then trigger a browser download from an object URL. */
export async function downloadAuthedFile(path: string, filename: string): Promise<void> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  if (!token) throw new Error("Not signed in");

  const res = await fetch(`${API_BASE_URL}${path}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) {
    let message = `Request failed (${res.status})`;
    try {
      const body = (await res.json()) as { error?: string };
      if (body.error) message = body.error;
    } catch {
      // ignore parse failure, use default message
    }
    throw new Error(message);
  }

  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
